var _filter, _filter2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchLookupImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 262,
    viewBox: "0 0 390 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33946_89826)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 262,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4399 33H287.025C290.335 33.0001 293.546 34.0946 296.162 36.1035L296.676 36.5176L323.038 58.6777H323.039L344.668 78.4072C347.784 81.2493 349.56 85.272 349.56 89.4893V332.438H67.4399V44C67.4399 37.9249 72.3648 33 78.4399 33Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_33946_89826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 133,
    width: 329,
    height: 56,
    rx: 10,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 167,
    width: 112,
    height: 6,
    rx: 3,
    fill: "#E1E4EA",
    style: {
      fill: "#E1E4EA",
      fill: "color(display-p3 0.8820 0.8955 0.9180)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 149,
    width: 145,
    height: 12,
    rx: 6,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 149,
    width: 40,
    height: 12,
    rx: 6,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33946_89826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 147.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#6FCBD4",
    style: {
      fill: "#6FCBD4",
      fill: "color(display-p3 0.4353 0.7961 0.8314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 147.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 152.75C55.6787 152.75 51.75 156.679 51.75 161.5C51.75 166.321 55.6787 170.25 60.5 170.25C65.3212 170.25 69.25 166.321 69.25 161.5C69.25 156.679 65.3212 152.75 60.5 152.75ZM64.6825 159.487L59.7212 164.449C59.5987 164.571 59.4325 164.641 59.2575 164.641C59.0825 164.641 58.9163 164.571 58.7938 164.449L56.3175 161.972C56.0637 161.719 56.0637 161.299 56.3175 161.045C56.5712 160.791 56.9912 160.791 57.245 161.045L59.2575 163.057L63.755 158.56C64.0087 158.306 64.4288 158.306 64.6825 158.56C64.9363 158.814 64.9363 159.225 64.6825 159.487Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_33946_89826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 201,
    width: 329,
    height: 56,
    rx: 10,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6586 215H55.75C54.7835 215 54 215.784 54 216.75V241.25C54 242.216 54.7835 243 55.75 243H73.25C74.2165 243 75 242.216 75 241.25V222.178L66.6584 222.178L66.6586 215Z",
    fill: "#F3F4F7",
    style: {
      fill: "#F3F4F7",
      fill: "color(display-p3 0.9528 0.9582 0.9672)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 221.295V221.303L67.5335 221.303L67.5336 215H67.5448L75 221.295Z",
    fill: "#F3F4F7",
    style: {
      fill: "#F3F4F7",
      fill: "color(display-p3 0.9528 0.9582 0.9672)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8011 231.314C67.7554 231.359 67.7011 231.396 67.6413 231.421C67.5814 231.446 67.5173 231.458 67.4525 231.458C67.3877 231.458 67.3236 231.446 67.2638 231.421C67.2039 231.396 67.1496 231.359 67.1039 231.314L64.992 229.202V235.231C64.992 235.361 64.9401 235.487 64.8478 235.579C64.7555 235.671 64.6303 235.723 64.4998 235.723C64.3693 235.723 64.2441 235.671 64.1518 235.579C64.0595 235.487 64.0076 235.361 64.0076 235.231V229.202L61.8949 231.314C61.8024 231.406 61.677 231.458 61.5463 231.458C61.4155 231.458 61.2901 231.406 61.1976 231.314C61.1052 231.221 61.0532 231.096 61.0532 230.965C61.0532 230.834 61.1052 230.709 61.1976 230.616L64.1508 227.663C64.1965 227.617 64.2508 227.581 64.3106 227.556C64.3705 227.531 64.4346 227.518 64.4994 227.518C64.5642 227.518 64.6283 227.531 64.6881 227.556C64.748 227.581 64.8023 227.617 64.848 227.663L67.8011 230.616C67.847 230.662 67.8834 230.716 67.9083 230.776C67.9331 230.836 67.9459 230.9 67.9459 230.965C67.9459 231.03 67.9331 231.094 67.9083 231.154C67.8834 231.213 67.847 231.268 67.8011 231.314Z",
    fill: "#C7CBD1",
    style: {
      fill: "#C7CBD1",
      fill: "color(display-p3 0.7820 0.7952 0.8180)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 235,
    width: 112,
    height: 6,
    rx: 3,
    fill: "#E7FAE3",
    style: {
      fill: "#E7FAE3",
      fill: "color(display-p3 0.9059 0.9804 0.8902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 235,
    width: 29,
    height: 6,
    rx: 3,
    fill: "#8BE27C",
    style: {
      fill: "#8BE27C",
      fill: "color(display-p3 0.5443 0.8880 0.4870)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 217,
    width: 145,
    height: 12,
    rx: 6,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 217,
    width: 40,
    height: 12,
    rx: 6,
    fill: "#F2F4F7",
    style: {
      fill: "#F2F4F7",
      fill: "color(display-p3 0.9490 0.9569 0.9686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 221,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F7F7F8",
    style: {
      fill: "#F7F7F8",
      fill: "color(display-p3 0.9676 0.9695 0.9724)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 146.44,
    y: 62,
    width: 93,
    height: 14,
    rx: 7,
    fill: "#E6EDFD",
    style: {
      fill: "#E6EDFD",
      fill: "color(display-p3 0.9020 0.9294 0.9922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.44,
    y: 84,
    width: 124,
    height: 14,
    rx: 7,
    fill: "#E6EDFD",
    style: {
      fill: "#E6EDFD",
      fill: "color(display-p3 0.9020 0.9294 0.9922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_33946_89826)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_33946_89826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 62,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109,
    cy: 79.9999,
    rx: 6.66667,
    ry: 6.66667,
    fill: "url(#paint0_linear_33946_89826)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.334 99.1667C122.334 103.309 122.334 106.667 109 106.667C95.667 106.667 95.667 103.309 95.667 99.1667C95.667 95.0246 101.637 91.6667 109 91.6667C116.364 91.6667 122.334 95.0246 122.334 99.1667Z",
    fill: "url(#paint1_linear_33946_89826)",
    style: {}
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 62,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33946_89826",
    x: 30,
    y: 133,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33946_89826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33946_89826",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_33946_89826",
    x: 74,
    y: 47.5,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33946_89826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33946_89826",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33946_89826",
    x1: 107.41,
    y1: 83.9972,
    x2: 121.495,
    y2: 65.2173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33946_89826",
    x1: 109,
    y1: 91.6667,
    x2: 109,
    y2: 103.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33946_89826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 262,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_33946_89826"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 133,
    width: 329,
    height: 56,
    rx: 10,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_33946_89826"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 201,
    width: 329,
    height: 56,
    rx: 10,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_33946_89826"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 62,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchLookupImg);
export default __webpack_public_path__ + "static/media/batch-lookup-img.10cdd2ad30456694209e832d14899525.svg";
export { ForwardRef as ReactComponent };